import React from 'react'
const SettingContextStep2 = React.createContext({})
export const SettingProviderStep2 = SettingContextStep2.Provider
export default SettingContextStep2